import React, { useState, useCallback } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import { SnackbarContext } from "hooks/useSnack";

type Snack = {
  id: number;
  message: string;
  severity?: AlertColor;
};

let idCounter = 0;

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snacks, setSnacks] = useState<Snack[]>([]);

  const showSnack = useCallback(
    (message: string, severity: AlertColor = "info") => {
      const id = idCounter++;
      setSnacks((prev) => [...prev, { id, message, severity }]);
    },
    [],
  );

  const handleClose = useCallback((id: number) => {
    setSnacks((prev) => prev.filter((s) => s.id !== id));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnack }}>
      {children}
      {snacks.map((snack, index) => (
        <Snackbar
          key={snack.id}
          open
          autoHideDuration={6000}
          onClose={() => handleClose(snack.id)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          style={{ bottom: 20 + index * 55 }}
          // Disable click away close
          ClickAwayListenerProps={{ onClickAway: () => null }}
        >
          <Alert
            style={{ minWidth: "200px" }}
            onClose={() => handleClose(snack.id)}
            severity={snack.severity}
            variant="filled"
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </SnackbarContext.Provider>
  );
};
